






import { Vue, Component, Prop } from "vue-property-decorator";
import { TooltipDirective } from '@share/directives/Tooltip';

@Component({directives: {TooltipDirective}})

export default class TooltipIcon extends Vue {

    @Prop() text: string;
    @Prop({ default: "?" }) char: string;

    get tooltipProps() {
        return this.text ? {
            title: this.text
        } : null;
    }
}

